export class PastStay extends Error {
  constructor() {
    super(`Invalid checkout public query: the check-in date is in the past.`);
    Object.setPrototypeOf(this, PastStay.prototype);
  }
}
